export function useActiveDialogs() {
  const activeDialogs = useState<string[]>("activeDialogs", () => []);
  const hasActiveDialog = computed(() => activeDialogs.value.length > 0);

  function register(id: string) {
    activeDialogs.value = [...new Set([...activeDialogs.value, id])];
  }

  function unregister(id: string) {
    activeDialogs.value = activeDialogs.value.filter((_id) => _id !== id);
  }

  return {
    register,
    unregister,
    hasActiveDialog,
  };
}
